export default __webpack_public_path__ + "static/media/learose2-480w.f4939d8b.webp";